<script setup lang="ts">
import { useField } from "vee-validate";

const props = defineProps<{
  name: "";
  multiple?: boolean;
  limit?: number;
  accept?: string;
  disabled?: boolean;
}>();

const { handleChange, setValue } = useField<File[]>(props.name, undefined, {
  initialValue: [],
});

const emit = defineEmits<{
  (e: "change", type: File[]): void;
}>();
function onChangeFile(e: InputEvent) {
  const target = e.target as HTMLInputElement;
  const files = target.files as FileList;

  const currentValues = props.limit
    ? [...files].slice(0, props.limit)
    : [...files];
  setValue(currentValues);
  handleChange(currentValues);
  emit("change", currentValues);
  target.value = "";
}
</script>

<template>
  <label>
    <slot />
    <input
      type="file"
      :name="props.name"
      :multiple="multiple"
      class="sr-only"
      :accept="accept"
      :disabled="disabled"
      @change="onChangeFile"
    />
  </label>
</template>
